import PrebidService from '@/api/admin/prebid.service'

export default {
  state: {
    prebidWrapper: {},
    adapterStats: [],
    prebidStatsData: {
      prebidAdapters: {},
      totalNumberOfBids: {},
      bidsWon: {},
      bidsLost: {},
    },
    table: {
      rows: [],
      searchTerm: '',
    },
  },
  getters: {
    prebidDashboardModel: state => state.prebidWrapper,
    adapterStats: state => state.adapterStats,
    prebidStatsData: state => state.prebidStatsData,
    adapterCodeTable: state => state.table,
  },
  actions: {
    async getPrebidDashboard({ commit }) {
      const response = await PrebidService.getPrebidDashboard()
      commit('SET_PREBID_DATA', response)
    },
    async getPrebidStats({ commit }, filter) {
      const response = await PrebidService.getStats(filter)
      commit('SET_PREBID_STATS_DATA', response)
    },
    async getAdapterStats({ commit }, filter) {
      const response = await PrebidService.getAdapterStats(filter)
      commit('SET_ADAPTER_STATS_DATA', response)
    },
  },
  mutations: {
    SET_PREBID_DATA(state, model) {
      state.prebidWrapper = model
    },
    SET_PREBID_STATS_DATA(state, model) {
      state.prebidStatsData.prebidAdapters = model.prebidAdapters
      state.prebidStatsData.totalNumberOfBids = model.totalNumberOfBids
      state.prebidStatsData.bidsWon = model.bidsWon
      state.prebidStatsData.bidsLost = model.bidsLost
    },
    SET_ADAPTER_STATS_DATA(state, model) {
      state.adapterStats = model
      state.table.rows = model
    },
  },
}
